// eslint-disable-next-line no-use-before-define
import { Icon, mediaQueries, palette, Select } from '@centivo/react-components'
import styled from 'styled-components'

import { SearchBarForm } from 'src/refactor/components/SearchBarForm'
import { ContentSection } from 'src/refactor/structure'

import { useMediaContext } from 'src/context/responsive'
import { CATEGORY } from '../../../../helpers/constants'
import { SearchBarButtonDefault } from './SearchBarButtonDefault'
import { useSearchBarFunctions } from './useSearchBarFunctions'
import SearchBarDisclaimerContent from './SearchBarDisclaimerContent'

const StyledContentSection = styled(ContentSection)`
  @media ${mediaQueries.mobile} {
    padding-bottom: calc(6.25rem - 2rem) !important;
  }
`

const SearchBarContentSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .network-selector {
    margin-bottom: 2.5rem;
    max-width: 430px;
    width: 100%;

    @media ${mediaQueries.desktop} {
      width: 440px;
      max-width: unset;
    }
  }
`

const SearchBarTitle = styled.h2`
  color: ${palette.brand.darkGreen};
  font-size: 1.875rem;
  font-weight: 700;
  line-height: 1.4;
  margin-bottom: 1rem;
  text-align: center;
`

const SearchBarButtonsGroup = styled.div`
  align-items: start;
  display: flex;
  justify-content: center;
  margin-bottom: 3.25rem;
`

export const SearchBarDefault = () => {
  const {
    state,
    networkSelectionEnabled,
    template,
    category,
    shouldShowDisclaimer,
    disableTabButtons,
    planNetworkOptions,

    handleNetworkSelected,
    toggleCategory,
    onSubmit,
  } = useSearchBarFunctions()

  const { isMobileView } = useMediaContext()

  return (
    <StyledContentSection id="find-a-doctor">
      <SearchBarContentSection>
        {template !== 'template-3' && (
          <SearchBarTitle>Find a doctor or facility</SearchBarTitle>
        )}
        {networkSelectionEnabled && (
          <Select
            className="network-selector"
            placeholder="Select your network"
            options={planNetworkOptions}
            onSelect={handleNetworkSelected}
            isSearchable={false}
            value={state.selectedPlan}
            isClearable
            float
          />
        )}
      </SearchBarContentSection>
      {!disableTabButtons && (
        <SearchBarButtonsGroup>
          <SearchBarButtonDefault
            selected={category === CATEGORY.DOCTOR}
            onClick={() => toggleCategory(CATEGORY.DOCTOR)}
            title="Doctor"
            icon={
              <Icon
                aria-hidden
                icon="slice-doctor"
                size={isMobileView ? '3.798rem' : '5rem'}
              />
            }
          />
          <SearchBarButtonDefault
            selected={category === CATEGORY.FACILITY}
            onClick={() => toggleCategory(CATEGORY.FACILITY)}
            title="Facility"
            icon={
              <Icon
                aria-hidden
                icon="slice-health"
                size={isMobileView ? '3.798rem' : '5rem'}
              />
            }
          />
        </SearchBarButtonsGroup>
      )}
      {!disableTabButtons && category && (
        <SearchBarForm
          category={category ?? CATEGORY.DOCTOR}
          onSubmit={onSubmit}
        />
      )}
      <SearchBarDisclaimerContent
        disableTabButtons={disableTabButtons}
        category={category}
      />
    </StyledContentSection>
  )
}
